import type { FC } from 'react';
import { FONT_SIZE, HEADER_HEIGHT, HEADER_RADIUS, LIFELINE_DASH, sequenceColors, } from './sequence-constants';
import type { SequenceLaneLayout } from './layout-sequence';
import { SequenceText } from './SequenceText';
import { FontWeight } from '@/theme/typography';
const ACTOR_GLYPH = '\u{1F464} ';
interface SequenceParticipantProps {
    lane: SequenceLaneLayout;
    headerTop: number;
    lifelineTop: number;
    lifelineBottom: number;
}
/**
 * A participant lane: the header box (with an actor glyph prefix for `actor`
 * lanes) plus its vertical lifeline. Mirrors FlowchartNode's box + centered
 * `<text>` shape, drawn as SVG.
 */
export const SequenceParticipant: FC<SequenceParticipantProps> = ({ lane, headerTop, lifelineTop, lifelineBottom, }) => {
    const { centerX, headerWidth, label, isActor } = lane;
    const boxX = centerX - headerWidth / 2;
    const displayLabel = isActor ? `${ACTOR_GLYPH}${label}` : label;
    return (
    <g>
      <line x1={centerX} y1={lifelineTop} x2={centerX} y2={lifelineBottom} stroke={sequenceColors.lifeline} strokeWidth={1} strokeDasharray={LIFELINE_DASH}/>

      <rect x={boxX} y={headerTop} width={headerWidth} height={HEADER_HEIGHT} rx={HEADER_RADIUS} ry={HEADER_RADIUS} fill={sequenceColors.headerFill} stroke={sequenceColors.headerStroke} strokeWidth={1}/>
      <SequenceText x={boxX} y={headerTop} width={headerWidth} height={HEADER_HEIGHT} content={displayLabel} size={FONT_SIZE} weight={FontWeight.SemiBold} color={sequenceColors.headerText} align="center" padX={8}/>
    </g>
    );
};
